<template>
  <div class="content-area">
    <hero-bar>
      {{ title }}
      <b-button
        slot="right"
        icon-left="content-save-off"
        type="is-warning"
        class="mr-3"
        tag="router-link"
        :to="{ name: 'specifications.index' }"
      >
        {{ $t('cancel') }}
      </b-button>
      <b-button
        slot="right"
        icon-left="content-save"
        type="is-link"
        :class="{'is-loading':isLoading}"
        @click="btnSubmit"
      >
        {{ $t('save') }}
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <card-component
        title="Tanımlama Formu"
        icon="ballot"
      >
        <form
          ref="form"
          @submit.prevent="submit"
        >
          <div class="columns">
            <div class="column">
              <b-field>
                <b-select
                  v-model="form.specification.type"
                  placeholder="* Tür Seçiniz *"
                  :disabled="!isCreate"
                  required
                  expanded
                >
                  <option value="1">Görev Türü</option>
                  <option value="2">Talep Eden Birim</option>
                  <option value="5">Talep Türü</option>
                </b-select>
              </b-field>
            </div>
            <div class="column">
              <b-field>
                <b-input
                  v-model.trim="form.specification.name"
                  type="text"
                  placeholder="Tanımlama Adı"
                  required
                />
              </b-field>
            </div>
          </div>
        </form>
      </card-component>
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'SpecificationCreateOrDetails',
  title: ({ $i18n }) => $i18n.t('createSpecification'),
  components: {
    HeroBar: () => import('@/components/HeroBar'),
    CardComponent: () => import('@/components/CardComponent'),
  },
  data () {
    return {
      isLoading: false,
      title: null,
      success_message: null,
      form: {
        specification: {
          name: '',
          type: null,
        },
      },
      id: null,
    }
  },
  computed: {
    ...mapState([
      'roles',
      'departments'
    ]),
    isCreate () {
      return this.$route.name === 'specifications.create'
    },
    defaultType () {
      const type = parseInt(this.$route.query.type)

      if (isNaN(type)) {
        return null
      }

      if (type === 2) {
        return 5
      }

      return type + 1
    },
  },
  beforeDestroy () {
    this.$store.commit('setAsideActiveMenuKey', '')
  },
  mounted () {
    if (this.roles.length == 0) {
      this.$store.dispatch('getRoles')
    }

    this.$store.commit('setAsideActiveMenuKey', 'specifications.index')

    if (this.isCreate) {
      this.title = this.$t('createSpecification')
      this.success_message = this.$t('created')
      this.form.specification.type = this.defaultType
    } else {
      this.title = this.$t('editSpecification')
      document.title = this.title
      this.success_message = this.$t('updated')
      this.showSpinner();

      this.$http.get('specifications/' + this.$route.params.id)
      .then(({ data }) => {
        if (data.data.id) {
          this.id = data.data.id;
          this.form.specification.name = data.data.name;
          this.form.specification.type = data.data.type;
        } else {
          this.$router.back();
        }
      })
      .catch(() => {
        this.$buefy.toast.open({
          message: this.$t('error'),
          type: 'is-warning',
        });
      })
      .finally(() => {
        this.hideSpinner();
      });
    }
  },
  methods: {
    btnSubmit () {
      if (this.$refs.form.checkValidity()) {
        this.submit();
      } else {
        this.$refs.form.reportValidity();
      }
    },
    submit () {
      this.isLoading = true;
      let actionURL, method;

      if (this.isCreate) {
        actionURL = 'specifications';
        method = 'POST';
      } else {
        actionURL = 'specifications/' + this.id;
        method = 'PUT';
      }

      this.$http({
        url: actionURL,
        method: method,
        data: this.form.specification
      })
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          this.$buefy.toast.open({
            message: this.success_message,
            type: 'is-success',
            queue: false
          });

          this.$router.go(-1)
        }
        this.isLoading = false;
      })
      .catch(e => {
        const errors = this.$_.flattenDeep(this.$_.values(e.response.data.error.errors)).join('<br>');
        this.$buefy.toast.open({
          message: `${this.$t('error')} : <br> ${errors}`,
          type: 'is-warning',
          duration: 5000
        });
        this.isLoading = false;
      });
    },
  }
}
</script>
